import Head from 'next/head'
import React from 'react'
import BottomCTA from '../common/components/BottomCTA'
import CompanyMission from './CompanyMission'
import Pitch from './Pitch'
import Values from './Values'
import SchemaMarkup from '../../components/SchemaMarkup'

function AboutUs() {
  return (
    <>
      <Head>
        <title>
          Fast, Reliable and Sustainable - About Us | Dimension Waste Management
        </title>
        <meta name="description" content="Dimension is the first tech-enabled service to radically simplify waste management for companies of any size, nationwide." />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <Pitch />
      <CompanyMission />
      <Values />
      <BottomCTA isProviderPortal={false} />
    </>
  )
}

export default AboutUs
